import type { CartPorts } from 'modules/cart'

import EditSaleOrderNotice from '../editSaleOrder/components/EditSaleOrderNotice'

import PlaceSaleOrderButton from './components/PlaceSaleOrderButton'

export const cartAdapters: CartPorts = {
  EditSaleOrderNotice
}

export const paymentCartAdapters: CartPorts = {
  ...cartAdapters,
  PaymentAction: PlaceSaleOrderButton
}
